"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var LinkedInSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14,3 C14.5522847,3 15,3.44771525 15,4 L15,14 C15,14.5522847 14.5522847,15 14,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,4 C3,3.44771525 3.44771525,3 4,3 L14,3 Z M10,8 L8,8 L8,14 L10,14 L10,11 L10.0067277,10.8833789 C10.0644928,10.3860402 10.4871642,10 11,10 C11.5128358,10 11.9355072,10.3860402 11.9932723,10.8833789 L12,11 L12,14 L14,14 L14,10.1650608 L13.997,10.165 L13.9948092,10.0959512 C13.9156449,8.92516159 12.940864,8 11.75,8 C11.1020593,8 10.5180873,8.27388215 10.1075375,8.71219283 L9.99995129,8.83572661 L10,8 Z M7,8 L5,8 L5,14 L7,14 L7,8 Z M6,5 C5.44771525,5 5,5.44771525 5,6 C5,6.55228475 5.44771525,7 6,7 C6.55228475,7 7,6.55228475 7,6 C7,5.44771525 6.55228475,5 6,5 Z" })));
};
LinkedInSmall.displayName = 'LinkedInSmall';
exports.default = LinkedInSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LinkedInSmall.js.map